<template>
    <div>
        <btn :icon="`fas fa-calculator`" 
             :click="() => show = true" 
             :cssClass="`btn btn-primary`"
        ></btn>

        <el-dialog
            title="Calculator"
            :visible.sync="show"
            append-to-body>

            <div class="flex-row">
                <div>Limit total recommended budget to:</div>
                <div class="input-group" style="max-width: 140px;">
                    <span class="input-group-addon">$</span>
                    <input type="number" class="form-control" v-model="data.budget" />
                </div>
            </div>
            <div class="flex-row">
                <div>MC should be</div>
                <div class="input-group" style="max-width: 100px;">
                    <input type="number" class="form-control" max="100" v-model="data.mc_cap" />
                    <span class="input-group-addon">%</span>
                </div>
                <div>of total budget (default: 50 %)</div>
            </div>

            <span slot="footer" class="dialog-footer">
                <btn :click="removeCap" cssClass="btn-default" icon="fal fa-times">Remove Cap</btn>
                <btn :click="calculate" cssClass="btn-primary">Calculate</btn>
            </span>

        </el-dialog>
    </div>
</template>

<script>
export default {
    props: [
        'data',
    ],
    data() {
        return {
            show: false,
        };
    },
    watch: {
        'data.mc_cap': function() {
            this.data.mc_cap = Math.max(Math.min(this.data.mc_cap, 100), 0);
            this.data.mc_cap = this.data.mc_cap ? this.data.mc_cap : '';
        },
    },
    methods: {
        calculate() {
            this.show = false;
            this.$emit('updated');
        },
        removeCap() {
            this.data.budget = null;
            this.data.mc_cap = null;
            this.show = false;
            this.$emit('updated');
        }
    },
};
</script>

<style scoped>
    .flex-row {
        display: flex; 
        flex-direction: row; 
        flex-wrap: nowrap; 
        justify-content: flex-start; 
        align-items: center;
        gap: 10px;
        margin-bottom: 10px;
    }
</style>
